import React from 'react';
import Icon from '../../../components/AppIcon';


const CustomerTable = ({ 
  customers = [], 
  onEdit, 
  onViewHistory, 
  onScheduleBooking,
  onDelete,
  selectedCustomers = [],
  onSelectCustomer,
  onSelectAll
}) => {
  const allSelected = customers?.length > 0 && selectedCustomers?.length === customers?.length;
  const someSelected = selectedCustomers?.length > 0 && !allSelected;

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead className="bg-muted border-b border-border">
          <tr>
            <th className="px-4 py-3 text-left w-12">
              <input
                type="checkbox"
                checked={allSelected}
                ref={input => {
                  if (input) input.indeterminate = someSelected;
                }}
                onChange={(e) => onSelectAll(e?.target?.checked)}
                className="w-4 h-4 rounded border-input text-primary focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background transition-smooth cursor-pointer"
                aria-label="Select all customers"
              />
            </th>
            <th className="px-4 py-3 text-left text-sm font-caption font-medium text-muted-foreground">
              Name
            </th>
            <th className="px-4 py-3 text-left text-sm font-caption font-medium text-muted-foreground">
              Phone
            </th>
            <th className="px-4 py-3 text-left text-sm font-caption font-medium text-muted-foreground">
              Email
            </th>
            <th className="px-4 py-3 text-left text-sm font-caption font-medium text-muted-foreground">
              Last Appointment
            </th>
            <th className="px-4 py-3 text-left text-sm font-caption font-medium text-muted-foreground">
              Total Visits
            </th>
            <th className="px-4 py-3 text-right text-sm font-caption font-medium text-muted-foreground">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-border">
          {customers?.map((customer) => (
            <tr 
              key={customer?.id}
              className="hover:bg-muted/50 transition-smooth"
            >
              <td className="px-4 py-4">
                <input
                  type="checkbox"
                  checked={selectedCustomers?.includes(customer?.id)}
                  onChange={(e) => onSelectCustomer(customer?.id, e?.target?.checked)}
                  className="w-4 h-4 rounded border-input text-primary focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background transition-smooth cursor-pointer"
                  aria-label={`Select ${customer?.name}`}
                />
              </td>
              <td className="px-4 py-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <span className="text-sm font-heading font-semibold text-primary">
                      {customer?.name?.split(' ')?.map(n => n?.[0])?.join('')?.substring(0, 2)}
                    </span>
                  </div>
                  <div className="min-w-0">
                    <div className="font-medium text-foreground truncate">
                      {customer?.name}
                    </div>
                    {customer?.servicePreference && (
                      <div className="text-xs text-muted-foreground truncate">
                        {customer?.servicePreference}
                      </div>
                    )}
                  </div>
                </div>
              </td>
              <td className="px-4 py-4">
                <span className="text-sm font-data text-foreground whitespace-nowrap">
                  {customer?.phone}
                </span>
              </td>
              <td className="px-4 py-4">
                <span className="text-sm text-foreground truncate max-w-[200px] inline-block">
                  {customer?.email}
                </span>
              </td>
              <td className="px-4 py-4">
                <span className="text-sm font-data text-foreground whitespace-nowrap">
                  {customer?.lastAppointment || 'Never'}
                </span>
              </td>
              <td className="px-4 py-4">
                <span className="text-sm font-data font-semibold text-foreground whitespace-nowrap">
                  {customer?.totalVisits}
                </span>
              </td>
              <td className="px-4 py-4">
                <div className="flex items-center justify-end gap-2">
                  <button
                    onClick={() => onEdit(customer)}
                    className="p-2 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted transition-smooth"
                    title="Edit customer"
                    aria-label={`Edit ${customer?.name}`}
                  >
                    <Icon name="Edit" size={18} />
                  </button>
                  <button
                    onClick={() => onViewHistory(customer)}
                    className="p-2 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted transition-smooth"
                    title="View appointment history"
                    aria-label={`View history for ${customer?.name}`}
                  >
                    <Icon name="History" size={18} />
                  </button>
                  <button
                    onClick={() => onScheduleBooking(customer)}
                    className="p-2 rounded-lg text-primary hover:bg-primary/10 transition-smooth"
                    title="Schedule new booking"
                    aria-label={`Schedule booking for ${customer?.name}`}
                  >
                    <Icon name="CalendarPlus" size={18} />
                  </button>
                  <button
                    onClick={() => onDelete(customer?.id)}
                    className="p-2 rounded-lg text-error hover:bg-error/10 transition-smooth"
                    title="Delete customer"
                    aria-label={`Delete ${customer?.name}`}
                  >
                    <Icon name="Trash2" size={18} />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CustomerTable;